import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useForm, useFormContext } from 'react-hook-form';
import { weeklyDaysList } from '../../../../constants/program.constants';
import FieldError from '../../../../shared/fields-errors/field-error';

function ProgramSchedule({programID, programDetails}) {
    const { register, watch, formState: {errors}, trigger, setValue } = useFormContext();
    const fieldsWatcher = watch();

    return (
        <>
            <div className='main-form-wrapper'>
                <h6 className="mb-3 text-black fw-bold">
                    <i className="fa-solid fa-calendar text-primary me-2"></i>
                    Program Dates
                </h6>

                {/* Date and Time Section */}
                <div className='row mb-2'>
                    <div className='col-xxl-6 col-md-12'>
                        <Form.Group >
                            <Form.Label className='text-bold text-black'>
                                <span className='text-danger'>*</span> Date & Time
                            </Form.Label>
                            <div className='d-flex gap-2'>
                                <Form.Control
                                {...register("schedule.start_date", {
                                    required:{
                                        value: true,
                                        message: "This field is required"
                                    },
                                    validate: (value) => {
                                         if(value){
                                            if(programID && programDetails?.schedule?.start_date){
                                                if(programDetails?.schedule?.start_date !== value){
                                                    return ((new Date(value) >= new Date().setHours(0,0,0,0)) || "Start date must be today or later")    
                                                }

                                                return true;
                                            }else{
                                                return ((new Date(value) >= new Date().setHours(0,0,0,0)) || "Start date must be today or later")
                                            }
                                            
                                        }
                                    }
                                })}
                                 type="date" placeholder="Select date"  style={{ flex: '2' }} />
                                 
                                <Form.Control 
                                {...register("schedule.start_time")}
                                type="text" placeholder="HH:MM" style={{ flex: '1' }} />
                            </div>
                        </Form.Group>
                        {errors?.schedule?.start_date ? <FieldError message={errors?.schedule?.start_date?.message} /> : ''}
                    </div>
                    <div className='col-xxl-6 col-md-12'>
                        <Form.Group >
                            <Form.Label className='text-bold text-black'>
                                {!fieldsWatcher?.schedule?.is_recurring ? <span className='text-danger'>*</span> : ''} End Time</Form.Label>
                            <Form.Control
                              {...register("schedule.end_time", {
                                required:{
                                    value: fieldsWatcher?.schedule?.is_recurring ? false : true,
                                    message: "This field is required"
                                }
                              })}
                             type="text" placeholder="HH:MM"  />
                        </Form.Group>
                    </div>
                </div>

                {/* Recurrence Checkbox */}
                <div className='row mb-4'>
                    <div className='col-xxl-12 col-md-12'>
                        <label className='d-flex align-items-center'>
                            <input
                        {...register("schedule.is_recurring", {
                            onChange: (event) => {
                                if(event.currentTarget.checked === false){
                                    setValue('schedule.end_date', null)
                                }
                            }
                        })}
                            type="checkbox"
                            className='me-1'
                        /> This program recurs regularly (e.g., every Sunday)
                        </label>
                    </div>
                </div>

                {/* Recurrence Type - Daily */}
                {
                    fieldsWatcher?.schedule?.is_recurring ? 
                    <>
                        <div className='row mb-2'>
                        <div className='col-xxl-12 col-md-12'>
                            <Form.Label className='text-bold text-black'>
                                <span className='text-danger'>*</span> Recurrence Type
                            </Form.Label>
                            <div className='d-flex gap-3'>
                                <label className='d-flex align-items-center'>
                                    <input className='me-1'
                                {...register("schedule.recurrence_type", {
                                    required:{
                                        value: true,
                                        message: "This field is required"
                                    }
                                })}
                                    type="radio"
                                    value="daily"
                                /> Daily
                                </label>
                                <label className='d-flex align-items-center'>
                                    <input className='me-1'
                                {...register("schedule.recurrence_type", {
                                    required:{
                                        value: true,
                                        message: "This field is required"
                                    }
                                })}
                                    type="radio"
                                    value="weekly"
                                /> Weekly
                                </label>
                                <label className='d-flex align-items-center'>
                                         <input className='me-1'
                                {...register("schedule.recurrence_type", {
                                    required:{
                                        value: true,
                                        message: "This field is required"
                                    }
                                })}
                                    type="radio"
                                    value="monthly"
                                /> Monthly
                                </label>
                            </div>
                            {errors?.schedule?.recurrence_type ? <FieldError message={errors?.schedule?.recurrence_type?.message} /> : ''}
                        </div>
                </div>

                {/* Recurrence Type - Weekly */}
                {fieldsWatcher?.schedule?.recurrence_type === 'weekly' && (
                    <>

                        <div className='row mb-4'>
                            <div className='col-xxl-12 col-md-12'>
                                <Form.Label className='text-bold text-black'>
                                    <span className='text-danger'>*</span> Repeat Every
                                </Form.Label>
                                <div className='d-flex gap-2 align-items-center'>
                                    <Form.Control
                                    {...register("schedule.recurrence_interval", {
                                        valueAsNumber: true,
                                        required:{
                                            value: true,
                                            message: "This field is required"
                                        }
                                    })}
                                     type="number" style={{ width: '80px' }} />
                                    <span>Week(s)</span>
                                    {errors?.schedule?.recurrence_interval ? <FieldError message={errors?.schedule?.recurrence_interval?.message} /> : ''}
                                </div>
                            </div>
                        </div>

                        <div className='row mb-4'>
                            <div className='col-xxl-12 col-md-12'>
                                <Form.Label className='text-bold text-black'>
                                    <span className='text-danger'>*</span> Day(s) of the Week
                                </Form.Label>
                                <div className='d-flex flex-wrap gap-3'>
                                    {weeklyDaysList.map((day, index) => (
                                        <label key={`day_of_week_${index}`} className='d-flex align-items-center'>
                                            <input className='me-1' 
                                        onChange={async () => await trigger()}
                                            {...register(day.value, {
                                                validate: day.value === 'schedule.recurs_on_sunday' ? () => {
                                                    return (
                                                        fieldsWatcher?.schedule?.recurs_on_sunday || fieldsWatcher?.schedule?.recurs_on_monday || fieldsWatcher?.schedule?.recurs_on_tuesday || fieldsWatcher?.schedule?.recurs_on_wednesday || fieldsWatcher?.schedule?.recurs_on_thursday || fieldsWatcher?.schedule?.recurs_on_friday || fieldsWatcher?.schedule?.recurs_on_saturday ||
                                                        "Select at least one option"
                                                    );
                                                } : () => {}
                                            })}
                                            type="checkbox"
                                        /> {day.label}
                                        </label>
                                    ))}
                                    {errors?.schedule?.recurs_on_sunday ? <FieldError message={errors?.schedule?.recurs_on_sunday?.message} /> : ''}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Recurrence Type - Monthly */}
                {fieldsWatcher?.schedule?.recurrence_type === 'monthly' && (
                    <>

                        <div className='row mb-4'>
                            <div className='col-xxl-12 col-md-12'>
                                <Form.Label className='text-bold text-black'>
                                    <span className='text-danger'>*</span> Repeat Every
                                </Form.Label>
                                <div className='d-flex gap-2 align-items-center'>
                                    <Form.Control
                                    {...register("schedule.recurrence_interval", {
                                        valueAsNumber: true,
                                        required:{
                                            value: true,
                                            message: "This field is required"
                                        },
                                                validate: (v) => {
                                                const num = Number(v);
                                                return num > 0 || "Number must be greater than 0";
                                            }
                                    })}
                                     type="number" style={{ width: '80px' }} />
                                    <span>Month(s)</span>
                                    {errors?.schedule?.recurrence_interval ? <FieldError message={errors?.schedule?.recurrence_interval?.message} /> : ''}
                                </div>
                            </div>
                        </div>

                        <div className='row mb-4'>
                            <div className='col-xxl-12 col-md-12'>
                                <Form.Label className='text-bold text-black'>
                                    <span className='text-danger'>*</span> Pattern Options:
                                </Form.Label>
                                <div className='mb-3'>
                                    <label className='d-flex align-items-center'>
                                        <input className='me-1'
                                        type="radio"
                                        {...register("schedule.recurrence_pattern_type", {
                                               required:{
                                            value: true,
                                            message: "This field is required"
                                        }
                                        })}
                                        value="day_of_month"
                                    /> On day
                                    </label>
                                </div>
                                
                                    <div className='d-flex gap-2 align-items-center mb-3 ms-4'>
                                        <Form.Control
                                        {...register("schedule.recurrence_day_of_month", {
                                            valueAsNumber: true,
                                                  required:{
                                            value: fieldsWatcher?.schedule?.recurrence_pattern_type === 'day_of_month' ? true : false,
                                            message: "This field is required"
                                        },
                                            validate: (v) => {
                                                const num = Number(v);
                                                return num > 0 || "Number must be greater than 0";
                                            }
                                        })}
                                         type="number" style={{ width: '80px' }} />
                                        <span>of the month</span>
                                        {errors?.schedule?.recurrence_day_of_month ? <FieldError message={errors?.schedule?.recurrence_day_of_month?.message} /> : ''}
                                    </div>
                                
                                <div className='mb-3'>
                                    <label className='d-flex align-items-center'>
                                        <input className='me-1'
                                    {...register("schedule.recurrence_pattern_type", {
                                               required:{
                                            value: true,
                                            message: "This field is required"
                                        }
                                    })}
                                        type="radio"
                                        value="day_of_week"
                                    /> On the
                                    </label>
                                </div>
                                
                                    <div className='d-flex gap-2 align-items-center ms-4 mb-3'>
                                        <Form.Select {...register("schedule.recurrence_week_of_month", {
                                            valueAsNumber: true,
                                                   required:{
                                            value: fieldsWatcher?.schedule?.recurrence_pattern_type === 'day_of_week' ? true : false,
                                            message: "This field is required"
                                        }
                                        })} style={{ width: '120px' }}>
                                            <option value="1">first</option>
                                            <option value="2">second</option>
                                            <option value="3">third</option>
                                            <option value="4">fourth</option>
                                            <option value="-1">last</option>
                                        </Form.Select>
                                        {errors?.schedule?.recurrence_week_of_month ? <FieldError message={errors?.schedule?.recurrence_week_of_month?.message} /> : ''}
                                        <Form.Select {...register("schedule.recurrence_day_name", {
                                               required:{
                                            value: fieldsWatcher?.schedule?.recurrence_pattern_type === 'day_of_week' ? true : false,
                                            message: "This field is required"
                                        }
                                        })} style={{ width: '150px' }}>
                                            <option value="friday">Friday</option>
                                            <option value="saturday">Saturday</option>
                                            <option value="sunday">Sunday</option>
                                            <option value="monday">Monday</option>
                                            <option value="tuesday">Tuesday</option>
                                            <option value="wednesday">Wednesday</option>
                                            <option value="thursday">Thursday</option>
                                        </Form.Select>
                                        <span>of the month</span>
                                        {errors?.schedule?.recurrence_day_name ? <FieldError message={errors?.schedule?.recurrence_day_name?.message} /> : ''}
                                    </div>
                                {errors?.schedule?.recurrence_pattern_type ? <FieldError message={errors?.schedule?.recurrence_pattern_type?.message} /> : ''}
                            </div>
                        </div>
                    </>
                )}
                    </> : ''
                }
                

                {/* End Date */}
                {
                    fieldsWatcher?.schedule?.is_recurring ? 
                    <div className='row'>
                    <div className='col-xxl-12 col-md-12'>
                        <Form.Group >
                            <Form.Label className='text-bold text-black'>
                                <span className='text-danger'>*</span> End Date
                            </Form.Label>
                            <Form.Control
                            {...register("schedule.end_date", {
                                required:{
                                    value: true,
                                    message: "This field is required"
                                },
                                validate: (val, formValues) => new Date(val) > new Date(formValues?.schedule?.start_date) || "End date must be greater then start date"
                            })}
                             type="date" placeholder="Select end date" />
                             {errors?.schedule?.end_date ? <FieldError message={errors?.schedule?.end_date?.message} /> : ''}
                        </Form.Group>
                    </div>
                </div> : ''
                }
                
            </div>
        </>
    );
}

export default ProgramSchedule;